import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import List from "../views/List";
import Detail from "../views/Detail";
import Test from "../views/Test";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/home/:page",
    name: "HomePage",
    component: Home,
  },
  {
    path: "/list/:id",
    name: "List",
    component: List,
  },
  {
    path: "/detal/:id",
    name: "Detail",
    component: Detail,
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
